import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ion-margin-top" }

import { IonContent, IonModal } from "@ionic/vue"
  interface Props {
    type: string
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'BottomModal',
  props: {
    type: {}
  },
  setup(__props: any) {

const props = __props;

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonModal), {
    trigger: props.type,
    "initial-breakpoint": 0.5,
    breakpoints: [0.5, 1.0]
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["trigger"]))
}
}

})